import { action, observable } from 'mobx';

import { ITabStateProvider } from './ITabStateProvider';
import { SearchEntryState } from './SearchEntryState';

export class SearchTabState {

    private id: string;
    private provider: ITabStateProvider;

    public displayName: string;
    public query: string;

    @observable
    public isLoading: boolean = false;

    @observable
    public page: number = 0;
    @observable
    public allPages: number = 1;
    @observable
    public count: number = 0;
    @observable
    public entries: SearchEntryState[] = [];

    constructor(displayName: string, id: string, parent: ITabStateProvider) {
        this.provider = parent;
        this.displayName = displayName;
        this.id = id;
        this.provider = parent;
        this.isLoading = true;
        this.query = '';
    }

    @action
    async setPage(x: number): Promise<void> {
        if (this.page !== x) {
            this.page = x;
            this.isLoading = true;
            await this.provider.Update(x, this);
        }
    }

    @action
    patch(patchObject: Partial<SearchTabState>) {
        if (patchObject.query !== undefined) {
            this.query = patchObject.query;
        }
        if (patchObject.count) {
            this.count = patchObject.count;
        }
        if (patchObject.allPages) {
            this.allPages = patchObject.allPages;
        }
        if (patchObject.entries) {
            this.entries = patchObject.entries;
        }
        if (patchObject.page) {
            this.page = patchObject.page;
        }
        this.isLoading = false;
    }

}
